import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchAllArtists } from '../api/artists';
import LoadingSpinner from '../components/LoadingSpinner';

const ArtistPage = () => {
    const [artists, setArtists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            setError(null);
            try {
                const fetchedArtists = await fetchAllArtists();
                if (!cancelled) setArtists(fetchedArtists);
            } catch (err) {
                if (!cancelled) {
                    setError(err.message);
                    toast.error('Error fetching artists: ' + err.message);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => { cancelled = true; };
    }, []);

    if (loading) return <LoadingSpinner />;
    if (error) return <div className="container"><p className="paragraph">Failed to load artists.</p></div>;

    return (
        <div className="container">
            <h1 className="header">Artists</h1>
            {artists.length === 0 ? (
                <p className="paragraph">No artists yet.</p>
            ) : (
                <div className="artists-grid">
                    {artists.map(artist => (
                        <Link
                            key={artist.artistID}
                            to={`/artists/${artist.artistID}`}
                            className="artist-tile"
                        >
                            <span className="artist-tile-name">{artist.name || 'Unknown'}</span>
                            {artist.description ? (
                                <span className="artist-tile-desc">{artist.description}</span>
                            ) : null}
                            <span className="artist-tile-count">
                                {artist.cardCount} {artist.cardCount === 1 ? 'card' : 'cards'}
                            </span>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ArtistPage;
